module.exports = __webpack_public_path__ + "img/yijianfankui.2f01ae93.png";